module.exports = __webpack_public_path__ + "static/media/cloud-upload.c6772f2b.svg";